import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import {
  Home24Regular,
  Home24Filled,
  DataTrending24Regular,
  DataTrending24Filled,
} from "@fluentui/react-icons";

const useStyles = makeStyles({
  bar: {
    display: "flex",
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    flexShrink: 0,
  },
  tab: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase100,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  tabActive: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
});

interface NavItemDef {
  path: string;
  label: string;
  icon: React.ReactElement;
  activeIcon: React.ReactElement;
}

const navItems: NavItemDef[] = [
  {
    path: "/",
    label: "Home",
    icon: <Home24Regular />,
    activeIcon: <Home24Filled />,
  },
  {
    path: "/sales-analytics",
    label: "Sales Analytics",
    icon: <DataTrending24Regular />,
    activeIcon: <DataTrending24Filled />,
  },
];

export const BottomTabBar: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className={styles.bar}>
      {navItems.map((item) => {
        const isActive =
          item.path === "/"
            ? location.pathname === "/"
            : location.pathname.startsWith(item.path);
        return (
          <button
            key={item.path}
            className={mergeClasses(styles.tab, isActive && styles.tabActive)}
            onClick={() => navigate(item.path)}
            aria-current={isActive ? "page" : undefined}
          >
            {isActive ? item.activeIcon : item.icon}
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
